import { Logo } from "~/icons";
import { NavigationItems } from "./NavigationItems";

export const DesktopSidebar = () => {
  return (
    <div
      className="hidden lg:fixed lg:bottom-0 lg:z-50 lg:flex lg:w-56 lg:flex-col"
      style={{ top: "var(--hub-banner-height, 0px)" }}
    >
      <div className="border-blueGrey flex grow flex-col gap-y-10 overflow-y-auto border-r bg-white p-5">
        <Logo />

        <nav className="flex flex-1 flex-col">
          <NavigationItems />
        </nav>
      </div>
    </div>
  );
};
